/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Meta_ConnectInputs */

const cs_integrations_meta_connect = /** @type {(inputs: Integrations_Meta_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojit Meta Business`)
};

const en_integrations_meta_connect = /** @type {(inputs: Integrations_Meta_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Meta Business`)
};

/**
* | output |
* | --- |
* | "Connect Meta Business" |
*
* @param {Integrations_Meta_ConnectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_meta_connect = /** @type {((inputs?: Integrations_Meta_ConnectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Meta_ConnectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_meta_connect(inputs)
	return cs_integrations_meta_connect(inputs)
});